import { get, patch, post, put } from "./api_helper"

// branches
const getOrderList = params => get(`admin/inspection/order/${params.weekId}/list`, params)
const getRtwOrderList = params => get(`admin/inspection/rtw-order/${params.weekId}/list`, params)

const getOrderDetail = (id) => get(`admin/inspection/order/${id}`)
const getRtwOrderDetail = (id) => get(`admin/inspection/rtw-order/${id}`)


const getOrderSizeDetail = (id) => get(`admin/inspection/order/${id}/detail`)
const getRtwOrderSizeDetail = (id) => get(`admin/inspection/rtw-order/${id}/detail`)

const postOrderData = params => post(`admin/inspection/order/${params.id}`, params)
const postRtwOrderData = params => post(`admin/inspection/rtw-order/${params.id}`, params)
const patchDefect = id => patch(`admin/inspection/rtw-order/${id}/defect`)

const postOrderMemo = params => post(`admin/inspection/order/${params.id}/memo`, params)
const postRtwOrderMemo = params => post(`admin/inspection/rtw-order/${params.id}/memo`, params)


const InspectionAPI = {
  getOrderList,
  getRtwOrderList,

  getOrderDetail,
  getRtwOrderDetail,

  getOrderSizeDetail,
  getRtwOrderSizeDetail,

  postOrderData,
  postRtwOrderData,

  patchDefect,

  postOrderMemo,
  postRtwOrderMemo
}

export default InspectionAPI